import React from "react";
import "./Banner.css";
import axios from "axios";
import { Link } from "react-router-dom";

function Banner() {
  return (
    <Link to="/registration">
      <section className="Banner">
        <div className="container-fluid p-0">
          <div className="banner_holder">
            <img
              src="/assets/images/home/banner/banner.png"
              className="ready_banner"
            />
          </div>
        </div>
      </section>
    </Link>
  );
}

export default Banner;
